// Charm icons (24×24, id charm_<id>). 1-px ink outline, light from top-left.
// Key: '.' transparent, 'o' ink outline, other chars per sprite.
import { sprite, type SpriteDef } from './types';

export const charmPenny = sprite(
  'charm_penny',
  {
    o: 'ink',
    b: 'bronze',
    c: 'copper',
    B: 'brick',
    r: 'brass',
    l: 'leaf',
    f: 'forest',
    C: 'clover',
    m: 'maroon',
  },
  [
    '........................',
    '...........oo...........',
    '........ooobbooo........',
    '......oobbbbbbccoo......',
    '.....obbbbbBBccccco.....',
    '....obbbBbbbbccBccco....',
    '...obbbBbbbbccccBccco...',
    '...obbBbbbbccccccbcco...',
    '..obbBbbrlfcclfcccbcco..',
    '..obbbbblCCflCCfccccco..',
    '..obbbbblCCflCCfccccco..',
    '.obbBbbcfCCffCCfccBbBBo.',
    '.obbBbccclffflfccBBbBBo.',
    '..obcccclCCflCCfBBBBBo..',
    '..occcccfCCffCCfBBBBBo..',
    '..occBcccffccffBBBbBmo..',
    '...occBccccccfBBBbBmo...',
    '...occcbccccBBfBbBmmo...',
    '....occcbccBBBBbBmmo....',
    '.....occcccbbBBBmmo.....',
    '......oocccBBBBmoo......',
    '........oooBBooo........',
    '...........oo...........',
    '........................',
  ],
);

export const charmSugar = sprite(
  'charm_sugar',
  { o: 'ink', w: 'white', p: 'paper', s: 'steel', l: 'lilacGrey' },
  [
    '........................',
    '........................',
    '...........oo...........',
    '.........oowwoo.........',
    '.......oopwwwwwoo.......',
    '.....oowwwwwwwwwwoo.....',
    '...oowwwwwwwwwwwwwwoo...',
    '..owwwwwwwwwwwwwwwwwwo..',
    '..opppwpwwwwwwwwwwwsso..',
    '..oppwpwwwwwwwwwwsssso..',
    '..oppppppwpwppwsssssso..',
    '..oppppppppwpslsssssso..',
    '..opppppppwpssssssssso..',
    '..owppppppppssssssssso..',
    '..opppppppppssssssssso..',
    '..opwpwpppppssslssssso..',
    '..opwpppppppssssssssso..',
    '...opwpppppwsssslssso...',
    '....oopppwpplsslssoo....',
    '......oopppwssssoo......',
    '........ooppssoo........',
    '..........oooo..........',
    '........................',
    '........................',
  ],
);

export const charmKnuckle = sprite(
  'charm_knuckle',
  { o: 'ink', b: 'brass', c: 'copper', g: 'gold', a: 'amber' },
  [
    '........................',
    '........................',
    '........................',
    '........................',
    '....oo...oo...oo...oo...',
    '...obco.obco.obco.obco..',
    '..obggcobggcobggcobggco.',
    '.obgoogagoogagoogagoogco',
    '.obaooagaooagaooagaooaco',
    '.obaooagaooagaooagaooaco',
    '.ocgoogcgoogcgoogcgoogco',
    '..obggcobggcobggcobggco.',
    '..ocgggbggggbggggbggco..',
    '...obggggggggggggggco...',
    '...obggbbbbbbbbbbggco...',
    '...ocggggggggggggggco...',
    '....ocgggggggggggggco...',
    '.....ocgaaaaaaaaggco....',
    '......ocgggggggggco.....',
    '.......occccccccco......',
    '........ooooooooo.......',
    '........................',
    '........................',
    '........................',
  ],
);

export const charmSparehand = sprite(
  'charm_sparehand',
  {
    o: 'ink',
    l: 'lilacGrey',
    w: 'white',
    p: 'paper',
    s: 'steel',
    d: 'dustyPink',
    r: 'rose',
    m: 'mulberry',
    c: 'cream',
    S: 'sand',
  },
  [
    '........................',
    '..........o..o..........',
    '.........oloolo.........',
    '.......oowpwwploo.......',
    '......olooppoplolo......',
    '.....owpwoppoppoplo.....',
    '.....owppoppoppoplo.....',
    '.....owppoppoppoplo.....',
    '.....owpsopsopsoplo.....',
    '..oo.owppoppoppoplo.....',
    '.owloowppoppoppoplo.....',
    '.olplowppsppsppsplo.....',
    '..owlowppsppsppsplo.....',
    '..owpspppsppsppsplo.....',
    '..olppspppppppppplo.....',
    '...ollospppppppplo......',
    '....ololpppppppplo......',
    '.....o.oooooooooo.......',
    '......odrorrorromo......',
    '......ommmmmmmmmmo......',
    '.......oooooooooo.......',
    '.........owccSo.........',
    '........oScSScSo........',
    '.........oSooSo.........',
  ],
);

export const charmGrease = sprite(
  'charm_grease',
  {
    o: 'ink',
    p: 'paper',
    s: 'steel',
    O: 'olive',
    m: 'mud',
    c: 'coral',
    M: 'maroon',
    r: 'red',
    b: 'blood',
    v: 'vermilion',
    g: 'gold',
    a: 'amber',
  },
  [
    '........................',
    '........................',
    '....................oo..',
    '...................opso.',
    '..................opsso.',
    '.................opsso..',
    '................opssooo.',
    '..........oooo.opssooOmo',
    '.........ossssopsso.ommo',
    '...ooo..ocooooosso...oo.',
    '..oMMMo.occcrboso.......',
    '.oMMoMMovccrrbboo.......',
    '.oMo.oMoccrrrrbbMo......',
    '.oMoobobbbbbbbbbbbo.....',
    '.oMo.ovvccrrrrbbMMo.....',
    '.oMo.ovgggggggggMMo.....',
    '.oMMoMogggbbbgggMMo.....',
    '..oMMMoaaaaaaaaaMMo.....',
    '...ooovvccrrrrbbMMo.....',
    '....obobbbbbbbbbbobo....',
    '.....ovvccrrrrbbMMo.....',
    '.....ovvccrrrrrbbMMo....',
    '......ooooooooooooo.....',
    '........................',
  ],
);

export const charmReceipt = sprite(
  'charm_receipt',
  { o: 'ink', w: 'white', p: 'paper', s: 'steel', k: 'khaki', l: 'lilacGrey', r: 'red', d: 'dusk' },
  [
    '........................',
    '......ooooooooooo.......',
    '....oowwwppppppppoo.....',
    '...osswppppppppsssso....',
    '...osoppppppsssssoso....',
    '....owoooooooooooko.....',
    '....owwpppppppppkko.....',
    '....owwpppppppppkko.....',
    '....owwlllllllplkko.....',
    '....owwpppppppppkko.....',
    '....owwlllllppplkko.....',
    '....owwpppppppppkko.....',
    '....owwllllllpllkko.....',
    '....owwpppppppppkko.....',
    '....owwllllpppllkko.....',
    '....owwpppppppppkko.....',
    '....owwppppppprrkko.....',
    '....owwdddddddddkko.....',
    '....owwpppppppppkko.....',
    '....owwpppppppppkko.....',
    '....owwpopppopppoko.....',
    '.....owo.opo.oko.o......',
    '......o...o...o.........',
    '........................',
  ],
);

export const charmDoggybag = sprite(
  'charm_doggybag',
  { o: 'ink', c: 'cream', s: 'sand', b: 'bronze', m: 'mauveGrey', B: 'brass', r: 'brick' },
  [
    '........................',
    '........................',
    '.........oo..oo.........',
    '......o.ocsoocso.o......',
    '.....osoocsoocsooso.....',
    '.....occcbbccbbccso.....',
    '.....ocbbbbbbbbbbbso....',
    '....ocbbbbbbbbbbbbso....',
    '....ommmmmmmmmmmmmmo....',
    '....oBBBBBBBBBBBBBBo....',
    '.....oooooooooooooo.....',
    '....obsssssssssssmro....',
    '....obsssssssssssmro....',
    '....obssossssssossmro...',
    '...obsssoooooooossmro...',
    '...obsssoooooooossmro...',
    '...obsssossssssossmro...',
    '...obbssssssssssssmro...',
    '...obbssssssssssssmro...',
    '...obsssssssssssssmro...',
    '...ommmmmmmmmmmmmmmro...',
    '...orrrrrrrrrrrrrrrrro..',
    '....ooooooooooooooooo...',
    '........................',
  ],
);

export const charmSaltcircle = sprite('charm_saltcircle', { o: 'ink', w: 'white', p: 'paper', s: 'steel' }, [
  '........................',
  '.........o..............',
  '........owoooooo........',
  '.....oooowwwpppwo.o.....',
  '....owpwpppwpwowwopo....',
  '....oppwpwoooowwwppo....',
  '....oppwoo....oowppo....',
  '...owwwpo......oppspo...',
  '..opwwoo........ooospo..',
  '..opwo............owpo..',
  '..opoo............owo...',
  '.opwppo...........opwo..',
  '..owoo............oppo..',
  '..owo.............oppo..',
  '..opoo............owso..',
  '..owwwo..........oposo..',
  '...opwpo........oppwso..',
  '....owwsoo.....opppoo...',
  '...oowpsopooooossopo....',
  '..owooopswpwppwpsowo....',
  '...o...osppspspso.o.....',
  '........oppooooo........',
  '.........oo.............',
  '........................',
]);

export const charmPreserves = sprite(
  'charm_preserves',
  {
    o: 'ink',
    r: 'red',
    w: 'white',
    b: 'brass',
    B: 'blood',
    p: 'paper',
    s: 'steel',
    m: 'mulberry',
    c: 'coral',
    W: 'wine',
    C: 'cream',
  },
  [
    '........................',
    '........................',
    '.....oooooooooooooo.....',
    '....orwwrrwwrrwwrrwo....',
    '....owrrwwrrwwrrwwro....',
    '...owwrrwwrrwwrrwwrro...',
    '...obbbbbbbbbbbbbbbbo...',
    '...oBooooooooooooooBBo..',
    '....oppppppppppppppoo...',
    '...orssssssssssssssmo...',
    '...orrcccBBBBBBWWWmmo...',
    '...orrcccBBBBBBWWWmmo...',
    '...orrcccBBBBBBWWWmmo...',
    '...orrcooooooooooWmmo...',
    '...orrcoCCCrrCCCoWmmo...',
    '...orrcoCCrcrrCCoWmmo...',
    '...orrcoCCrrrrCCoWmmo...',
    '...orrcoCCCrrCCCoWmmo...',
    '...orrcooooooooooWmmo...',
    '...orrcccBBBBBBWWWmmo...',
    '...orrcccBBBBBBWWWmmo...',
    '....orrccBBBBBBWWmmo....',
    '.....oooooooooooooo.....',
    '........................',
  ],
);

export const charmPocketwatch = sprite(
  'charm_pocketwatch',
  { o: 'ink', g: 'gold', l: 'lemon', b: 'brass', d: 'dusk', c: 'cream', a: 'amber', r: 'red', C: 'copper' },
  [
    '..........oooo..........',
    '.........oggggo.........',
    '.........oggggo.........',
    '........oggooggo........',
    '.........oolloo.........',
    '.......oooboobooo.......',
    '......obbbbbbbbggo......',
    '.....obbbbbbbbggggo.....',
    '....obbbbooddooggggo....',
    '...obbbooccccccoogggo...',
    '...obbbocccoccccogggo...',
    '...obboccccocccccoggo...',
    '..obbboccccocccccoggao..',
    '..obbbdccccocccccdgaao..',
    '..obbbdccccroccccdaaao..',
    '..obbboccccccooccoaaao..',
    '...obgoccccccccocoaao...',
    '...ogggoccccccccoaaCo...',
    '...ogggooccccccooaCCo...',
    '....oggggooddooaaCCo....',
    '.....oggggggaaaaCCo.....',
    '......oggggaaaaCCo......',
    '.......oooaaaaooo.......',
    '..........oooo..........',
  ],
);

export const charmPairdice = sprite(
  'charm_pairdice',
  { o: 'ink', w: 'white', r: 'red', p: 'paper', s: 'steel' },
  [
    '........................',
    '......oooo..............',
    '....oowwwwoo............',
    '..oowwwwwwwwoo..........',
    '.owwwwwrrwwwwwo.........',
    'oppwwwwwwwwwwso.........',
    'oppppwwwwwwssso.........',
    'oppppppwwssssso.........',
    'opppppppssssssoooo......',
    'oppoppppsssossowwwoo....',
    'opppppppssssoowowwwwoo..',
    'opppppppsoooowwwwwwowwo.',
    '.oopppppsowwwwwwowwwwwso',
    '...oopopsoppwwwwwwwwssso',
    '.....oopsoppppwwwwssssso',
    '.......oopppppppsssssoso',
    '........opopppppsssossso',
    '........opppppppsossssso',
    '........opppppppssssssso',
    '........opppopppsssssoso',
    '.........oopppppsssosoo.',
    '...........oopppsosoo...',
    '.............oopsoo.....',
    '...............oo.......',
  ],
);

export const charmRubberband = sprite(
  'charm_rubberband',
  { o: 'ink', p: 'peach', v: 'vermilion', b: 'brick', r: 'rust', m: 'maroon' },
  [
    '........................',
    '........................',
    '........................',
    '........................',
    '......o...oooooooo......',
    '.....opooovvvvvvvvoo....',
    '....opoovvvvvvvvvvvvo...',
    '.....ovvvvvvooooovbbbo..',
    '....ovvvvooo.....oobbo..',
    '...ovvvoo.........obbbo.',
    '..ovvvo...........obbbo.',
    '..ovvo............obbbo.',
    '.ovvvo............obbo..',
    '.orrro...........ombbo..',
    '.orrro.........oobbmo...',
    '..orroo.....ooobbbbo....',
    '..orrrbooooobbbbbbo.....',
    '...obbbbbbbbbbbboo......',
    '....oobbbbbbbboo........',
    '......oooooooo..........',
    '........................',
    '........................',
    '........................',
    '........................',
  ],
);

export const charmGum = sprite(
  'charm_gum',
  {
    o: 'ink',
    p: 'pinkLilac',
    s: 'salmonPink',
    w: 'white',
    d: 'dustyPink',
    b: 'blue',
    P: 'paper',
    i: 'indigo',
    c: 'cobalt',
    S: 'steel',
  },
  [
    '........................',
    '.........oooooo.........',
    '.......ooppppppoo.......',
    '......oppppppppsso......',
    '.....oppppppppsssso.....',
    '....opwpwppppsssssso....',
    '...opwpwwwppsssssssso...',
    '...opppwwwpssssssssso...',
    '...oppppwpsssssssssdo...',
    '...opppppsssssssssddo...',
    '...oppppsssssssssdddo...',
    '...opppsssssssssddddo...',
    '...oppsssssssssdddddo...',
    '....osssssssssdddddo....',
    '.....osssssssdddddo.....',
    '......osssssdddddo......',
    '.......oossddddoo.......',
    '.........oddddo.........',
    '....oooooooooooooooo....',
    '...obbbbbbPPPPbbbbbio...',
    '...obcccccPPPPcccccio...',
    '...oiiiiiiSSSSiiiiiio...',
    '....oooooooooooooooo....',
    '........................',
  ],
);

export const charmPiggy = sprite(
  'charm_piggy',
  { o: 'ink', d: 'dustyPink', r: 'rose', s: 'salmonPink', p: 'pinkLilac', m: 'mulberry' },
  [
    '........................',
    '........................',
    '........................',
    '.........o......o.......',
    '........odo....oro......',
    '........odo...orro......',
    '.......odoooooorro......',
    '......osooossssooro.....',
    '....oossssssssdddooo....',
    'o..osssppssssdddddddo...',
    '.o.ossspppssddddodddoo..',
    'ososssssssddddddddddoso.',
    '.oossssssdddddddddrossso',
    '..ossssddddddddddrrorsso',
    '..osssddddddddddrrrroso.',
    '...osdddddddddrrrrrroo..',
    '...odddddddddrrrrrrmo...',
    '....oooddddrrrrrrmoo....',
    '.....odoodrrrroooo......',
    '.....odrrooooodrro......',
    '.....odrro...odrro......',
    '......ooo.....ooo.......',
    '........................',
    '........................',
  ],
);

export const charmThimble = sprite(
  'charm_thimble',
  { o: 'ink', p: 'paper', s: 'steel', d: 'dusk', w: 'white', l: 'lilacGrey' },
  [
    '........................',
    '........................',
    '........................',
    '..........oooo..........',
    '........oopssdoo........',
    '.......opwwsssldo.......',
    '......opswdsdsdldo......',
    '.....ospswdsdsdlddo.....',
    '.....oppwwssssllddo.....',
    '.....opswssdsdldddo.....',
    '.....opswssdsdldddo.....',
    '.....oppwwssssllddo.....',
    '.....ospswdsdsdlddo.....',
    '....opswssdsdsdldddo....',
    '....oppwwssssssllddo....',
    '....ospswdsdsdsdlddo....',
    '....oppwwssssssllddo....',
    '....ollllllllllllllo....',
    '....owwwwppppppssllo....',
    '....owwwwppppppssllo....',
    '....owwwwppppppssllo....',
    '.....oooooooooooooo.....',
    '........................',
    '........................',
  ],
);

export const CHARM_SPRITES: SpriteDef[] = [
  charmPenny,
  charmSugar,
  charmKnuckle,
  charmSparehand,
  charmGrease,
  charmReceipt,
  charmDoggybag,
  charmSaltcircle,
  charmPreserves,
  charmPocketwatch,
  charmPairdice,
  charmRubberband,
  charmGum,
  charmPiggy,
  charmThimble,
];
